import { Flex } from "@chakra-ui/react";
import { NavLink, type NavLinkProps, useMatch } from "react-router-dom";
import type { ReactNode } from "react";

type SidebarLinkProps = {
	icon: ReactNode;
};

function SidebarLink({
	children,
	icon,
	to,
	...props
}: NavLinkProps & SidebarLinkProps) {
	const isActive = useMatch(to.toString());

	if (isActive) {
		return (
			<Flex
				bg="white"
				rounded="lg"
				px="6px"
				py="8px"
				boxShadow="sm"
				color="brand.700"
				fontWeight="600"
				fontSize="14px"
				lineHeight="21px"
			>
				<NavLink to={to} {...props} style={{ width: "100%" }}>
					<Flex align="center" gap="2">
						<>
							{icon} {children}
						</>
					</Flex>
				</NavLink>
			</Flex>
		);
	}
	return (
		<Flex
			px="6px"
			py="8px"
			color="gray.700"
			fontWeight="600"
			fontSize="14px"
			lineHeight="21px"
		>
			<NavLink to={to} {...props} style={{ width: "100%" }}>
				<Flex align="center" gap="2">
					<>
						{icon} {children}
					</>
				</Flex>
			</NavLink>
		</Flex>
	);
}

export default SidebarLink;
